var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.menuShow,
          expression: "menuShow",
        },
      ],
      staticClass: "contextmenu",
      style: { top: _vm.menuTop + "px", left: _vm.menuLeft + "px" },
    },
    [
      _c(
        "ul",
        { on: { mouseup: _vm.handleMouseUp } },
        [
          _vm.curComponent
            ? [
                !_vm.curComponent.isLock
                  ? [
                      _vm.editFilter.includes(_vm.curComponent.type)
                        ? _c("li", { on: { click: _vm.edit } }, [
                            _vm._v(" " + _vm._s(_vm.$t("panel.edit"))),
                          ])
                        : _vm._e(),
                      _c("li", { on: { click: _vm.copy } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.copy"))),
                      ]),
                      _c("li", { on: { click: _vm.cut } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.cut"))),
                      ]),
                      _c("li", { on: { click: _vm.deleteComponent } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.delete"))),
                      ]),
                      _c("li", { on: { click: _vm.topComponent } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.topComponent"))),
                      ]),
                      _c("li", { on: { click: _vm.bottomComponent } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.bottomComponent"))),
                      ]),
                      _c("li", { on: { click: _vm.upComponent } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.upComponent"))),
                      ]),
                      _c("li", { on: { click: _vm.downComponent } }, [
                        _vm._v(" " + _vm._s(_vm.$t("panel.downComponent"))),
                      ]),
                    ]
                  : _c("li", { on: { click: _vm.unlock } }, [_vm._v("解锁")]),
              ]
            : _c("li", { on: { click: _vm.paste } }, [_vm._v("粘贴")]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }